import {
  action
} from 'mobx'
import { getQueryVariable } from 'Utils/utils';

class pageLoadStore {
  // @observable isLogin = false;

  @action async pageOnload() {
    // 打开第三方处理: 仅保留docs跳转逻辑（带url、documentName参数）
    // 不在使用objectId为参数的第三方链接；
    let url = getQueryVariable('url')
    let documentName = getQueryVariable('documentName')
    if (url) {
      // 打开错误关闭loading关闭网页
      setTimeout(() => {
        window.pdfui.openPDFByHttpRangeRequest({
          range: {
              url: decodeURIComponent(url)
          }
        }, { fileName: decodeURIComponent(decodeURIComponent(documentName))+".pdf" })
      }, 1000)
      return
    }
  }
}


export default pageLoadStore;
